export default __webpack_public_path__ + "static/media/Trash_Btn.e412c0ee.svg";